import Axios from 'axios';

import store from '@/store';
import router from '@/router.js';

const sleep = m => new Promise(r => setTimeout(r, m));

let tokenIsFresh = false;
let retryCount = 0;

const Request = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

Request.interceptors.request.use(async config => {
  const idToken = localStorage.getItem('id_token');

  if (idToken) {
    config.headers.Authorization = `Bearer ${idToken}`;
    return config;
  } else {
    await store.dispatch('user/logout');
    return {
      ...config,
      cancelToken: new Axios.CancelToken(cancel => cancel('No token provided')),
    };
  }
});

Request.interceptors.response.use(
  response => {
    retryCount = 0;
    tokenIsFresh = false;
    return response;
  },
  async error => {
    const { config, response } = error;

    const originalRequest = config;
    if (response) {
      const status = response.status;
      if (status === 403) {
        store.dispatch('user/restrict');
      }
      if (status === 401) {
        if (!tokenIsFresh) {
          await store.dispatch('user/refreshToken');
          tokenIsFresh = true;
        }

        if (retryCount < 8) {
          await sleep(1500);

          retryCount++;

          const retryResponse = await Request(originalRequest);

          return retryResponse;
        } else {
          const lastRoute = router.currentRoute.fullPath;
          sessionStorage.setItem('last_route', lastRoute);

          await store.dispatch('user/logout');
        }
      }
    }

    if (error instanceof Axios.Cancel) {
      return {
        cancelled: true
      }
    }

    return error;
  }
);

export default Request;
